export const name = 'siteThemeService' as const
export { VSM_EDITOR_CONFIGS_EXPERIMENT as editorExperiment } from '@wix/thunderbolt-symbols'
export const VIEWER_SERVICE_PACKAGE_NAME = '@wix/viewer-service-site-theme' as const
